/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @author Alexander Golshtein
 * @version 1.25.1
 * @since 1.25.0
 */

import styled from 'styled-components';

import { colors } from '@/main/theme';

export const PageNewsContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;
export const PageNewsWrapperStyled = styled.div`
    display: grid;
    grid-template-columns: 1fr 3fr;
    padding: 6px 0;
    border-top: 1px solid ${colors.borderColorDisabled};
    height: 100%;
`;
